module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"hello":"Hello i18n in SFC!"}}')
  delete Component.options._Ctor
}
